import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  fetchCommandRequest: ['id'],
  fetchCommandBufferRequest: ['id'],
  fetchCommandSuccess: ['tracker'],
  fetchCommandFailure: [],
  fetchCommandBufferSuccess: ['buffer'],
  fetchCommandBufferFailure: [],
  setViewModal: ['modalType'],
  createCommand: ['body'],
  fetchCreateSuccess: [],
  fetchCreateFailure: [],
  setModalShare: [],
  clearTrackerId: [],
});

const INITIAL_STATE = {
  commands: [],
  tracker: {},
  buffer: {},
  commandList: {},
  loading: false,
  loadingBuffer: false,
  tracker_id: null,
  viewModal: false,
  modalType: '',
  modalShare: false,
};

const fetchCommandRequest = (state = INITIAL_STATE, { id }) => ({
  ...state,
  loading: true,
  tracker_id: id,
});

const fetchCommandBufferRequest = (state = INITIAL_STATE) => ({
  ...state,
  loadingBuffer: true,
});

const fetchCommandSuccess = (
  state = INITIAL_STATE,
  { tracker, commands, commandList, buffer }
) => ({
  ...state,
  commands,
  tracker,
  buffer,
  commandList,
  loading: false,
});

const fetchCommandFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  commands: [],
  tracker: {},
  buffer: {},
  commandList: {},
});
const fetchCommandBufferSuccess = (state = INITIAL_STATE, { buffer }) => ({
  ...state,
  buffer,
  loadingBuffer: false,
});

const fetchCommandBufferFailure = (state = INITIAL_STATE) => ({
  ...state,
  loadingBuffer: false,
  buffer: {},
});

const setViewModal = (state = INITIAL_STATE, { modalType }) => ({
  ...state,
  viewModal: !state.viewModal,
  modalType,
});

const createCommand = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const fetchCreateSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  viewModal: false,
  modalType: '',
});

const fetchCreateFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const setModalShare = (state = INITIAL_STATE) => ({
  ...state,
  modalShare: !state.modalShare,
});

const clearTrackerId = (state = INITIAL_STATE) => ({
  ...state,
  tracker_id: null,
  commands: [],
  tracker: {},
  buffer: {},
  commandList: {},
});

export default createReducer(INITIAL_STATE, {
  [Types.FETCH_COMMAND_REQUEST]: fetchCommandRequest,
  [Types.FETCH_COMMAND_SUCCESS]: fetchCommandSuccess,
  [Types.FETCH_COMMAND_FAILURE]: fetchCommandFailure,
  [Types.FETCH_COMMAND_BUFFER_REQUEST]: fetchCommandBufferRequest,
  [Types.FETCH_COMMAND_BUFFER_SUCCESS]: fetchCommandBufferSuccess,
  [Types.FETCH_COMMAND_BUFFER_FAILURE]: fetchCommandBufferFailure,
  [Types.SET_VIEW_MODAL]: setViewModal,
  [Types.CREATE_COMMAND]: createCommand,
  [Types.FETCH_CREATE_SUCCESS]: fetchCreateSuccess,
  [Types.FETCH_CREATE_FAILURE]: fetchCreateFailure,
  [Types.SET_MODAL_SHARE]: setModalShare,
  [Types.CLEAR_TRACKER_ID]: clearTrackerId,
});
